<div #stepForm>
  <div class="grid-x grid-margin-x">
    <h1 class="cell small-12 large-offset-2 large-8 text-center" [innerHTML]="'moderat.bestandsaufnahme.start.headline' | translate"></h1>
    <div class="cell small-12 medium-offset-1 medium-3 large-offset-2 large-3">
      <app-advisor-image path="/moc/bestandsaufnahme-start.svg"></app-advisor-image>
    </div>
    <div class="cell small-12 medium-7 large-5">
      <p [innerHTML]="'moderat.bestandsaufnahme.start.teaser' | translate"></p>
    </div>
    <div class="cell small-12 medium-offset-1 medium-10 large-offset-2 large-8 ">
      <div class="callout secondary" [innerHTML]="'moderat.bestandsaufnahme.start.callout' | translate"></div>
      <app-step-buttons previousLink="../../verbrauchsanalyse/ergebnis" [nextLink]="steps?.nextStep? steps.nextStep.path : null" [nextSubmit]="false" mediumWidthRight="auto" mediumOffset="0" largeOffset="0" largeWidthRight="auto" nextText="moderat.bestandsaufnahme.start.next"></app-step-buttons>
    </div>
  </div>
</div>
